<template>
  <div id="app">
    <router-view />
    <div class="foot">本系统由德阳指尖秘码科技有限公司提供技术支持</div>

  </div>
</template>
<script>
export default {
  components: {
    // topheader,
  },
  data() {
    // var times = new Date().Format("yyyy-MM-dd hh:mm:ss")

    // 将日期格式化...将格式化加载这个函数的原型上....
    Date.prototype.Format = function (fmt) {
      //author: meizz
      var o = {
        'M+': this.getMonth() + 1, //月份
        'd+': this.getDate(), //日
        'h+': this.getHours(), //小时
        'm+': this.getMinutes(), //分
        's+': this.getSeconds(), //秒
        'q+': Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds(), //毫秒
      }
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (this.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
      for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ('00' + o[k]).substr(('' + o[k]).length)
          )
      return fmt
    }
    return {}
  },
  mounted() {

    // window.onresize = ()=>{ // 定义窗口大小变更通知事件
    //   // console.log(document.documentElement.clientHeight )//窗口宽度;
    //   window.history.go(0)
    // };

        




  },


}
</script>


<style lang="less">
#app {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  position: relative;
  flex-direction: column;
  .foot {
    font-size: 0.6rem;
    color: #088cdd;
    position: absolute;
    bottom: 0px;
    right: 15px;
  }
  // .appleft{ position: absolute; top:0; left:0; height: 100%; width: 990px; flex-direction: column; overflow: hidden; padding:0 0.5rem 0.5rem; display: flex;
  //   .top{ height: 4.2rem; flex-shrink: 0;}
  //   .bottom{ display: flex; flex-direction: column; overflow: hidden; height: 100%; flex: 1;
  //     .mybox{ flex: 1;}
  //   }
  // }
  // .appright{ position: absolute; top: 0; right: 0; height: 100%; width: 990px; flex-direction: column; overflow: hidden; padding:0 0.5rem 0.5rem; display: flex;
  //   .top{ height: 4.2rem; flex-shrink: 0;}
  //   .bottom{ display: flex; flex-direction: column; overflow: hidden; height: 100%; flex: 1;
  //     .mybox{ flex: 1;}
  //   }
  // }
}
</style>








